import React, { Component } from 'react';
import autoBind from 'react-autobind';
import * as themeReducer from '@common/store/theme/theme.reducer';
import themeActions from '@common/store/theme/theme.actions';
import navbarService from '../../navbar.service';
import { connect } from 'react-redux';
import { GlobalContext } from '@common/store/context';
import SmartModal from '@common/components/modals/smartModal';
import { Modal, Row, Col } from 'react-bootstrap';

class NavbarChangeTheme extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  changeTheme(index) {
    const { themes } = this.props;
    const selectedTheme = themes[index];

    this.props.setTheme(selectedTheme);
    this.saveTheme(selectedTheme.path);
  }

  async saveTheme(theme) {
    await navbarService.authorization.updateUserTheme(theme);
  }

  render() {
    const { theme, themes, showChangeThemeModal, onClose } = this.props;

    return (
      <SmartModal show={showChangeThemeModal} size="lg" backdrop="static" onHide={onClose} keyboard>
        <Modal.Header>
          <Modal.Title>
            <h3>Escolha um tema</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ul className="all-themes">
            {themes.map((item, index) => (
              <li key={index} onClick={() => this.changeTheme(index)}>
                <label>{item.title}</label>
                <img
                  src={item.url}
                  alt={item.title}
                  className={theme == item.path ? 'theme-image img-thumbnail selected' : 'theme-image img-thumbnail'}
                />
                {theme == item.path && <span className="fa fa-check selected"></span>}
              </li>
            ))}
          </ul>
        </Modal.Body>

        <Modal.Footer>
          <Row>
            <Col className="btn-forms">
              <button onClick={onClose} className="btn btn-primary">
                <i className="fa fa-angle-double-left" /> Voltar
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </SmartModal>
    );
  }
}

const mapDispatchToProps = (disptach) => {
  return {
    setTheme: (selectedTheme) => disptach(themeActions.set(selectedTheme)),
  };
};

const mapStateToProps = (state) => {
  return {
    theme: themeReducer.getTheme(state),
    themes: themeReducer.getThemes(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, GlobalContext)(NavbarChangeTheme);
